import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { handleChange } from "../../generalReducer/action/GlobalAction";

const ProjectHooks = () => {
  const dispatch = useDispatch();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const handleOpenLightbox = () => {
    dispatch(handleChange({ lightbox_status: true }));
    setLightboxOpen(true);
  };
  return {
    lightboxOpen,
    handleOpenLightbox,
  };
};

export default ProjectHooks;
